export default __webpack_public_path__ + "static/icon-zonav-act-bedb2cf4c590c5bc7eb6aed624e1f6a4.png";